Game.Utils.PlayerEffects = {

	/**
	 * Run the physics for the specified man.
	 *
	 * @param  {man} man The man to adjust.
	 * @return {null}
	 */
	run: function( man ) {

		if ( ! man.alive ) {
			return;
		}

		// Run a physics method based upon wether there is one available for the
		// current state or not.
		if ( 'function' === typeof this[ 'run_' + man.state ] ) {
			this[ 'run_' + man.state ]( man );
		}

		if ( this.canExplode( man ) ) {
			this.resetExplode( man );
		}

	},


	canExplode: function( man ) {

		if ( ! man.emit_effect ) {
			return true;
		}

		if ( man.emit_effect < game.time.time ) {
			return true;
		}

		return false;

	},


	resetExplode: function( man ) {

		var offset;

		switch( man.state ) {

			case Game.Prefabs.Man.states.FLY:

				offset = 200;
				break;

			case Game.Prefabs.Man.states.JUMP:

				offset = 150;
				break;

			default:

				offset = 250;

		}

		man.emit_effect = game.time.time + offset;

	},


	/**
	 * Do physics for walking.
	 *
	 * @param  {Object} man [description]
	 */
	run_1: function( man ) {

		if ( Math.abs( man.body.velocity.x ) > 30 && this.canExplode( man ) ) {

			new Game.Prefabs.EffectDust( game, man.x, man.y );

		}

		if ( man.controls.down && ! man.controls.up ) {

			// Traveling fast then let's slide instead!
			if ( Math.abs( man.body.velocity.x ) > 20 ) {

				new Game.Prefabs.EffectDustSlide( game, man.x, man.y );

			}

		}

		if ( man.controls.left && man.body.velocity.x > 0 ) {

			new Game.Prefabs.EffectDustSlide( game, man.x, man.y );

		}

		if ( man.controls.right && man.body.velocity.x < 0 ) {

			new Game.Prefabs.EffectDustSlide( game, man.x, man.y );

		}

	},


	/**
	 * Flying.
	 *
	 * @param {Object} man [description]
	 */
	run_2: function( man ) {

		if ( this.canExplode( man ) ) {

			new Game.Prefabs.EffectRocketBoots( game, man.x, man.y );

		}

	},


	/**
	 * Jumping/ Falling.
	 *
	 * @param {Object} man [description]
	 */
	run_3: function( man ) {

		if ( this.canExplode( man ) ) {

			new Game.Prefabs.EffectDust( game, man.x, man.y );

		}

	},


	/**
	 * Do physics for crawling.
	 *
	 * @param  {Object} man [description]
	 */
	run_4: function( man ) {


	},

	run_9: function( man ) {


	},


	run_5: function( man ) {


	},

	run_6: function( man ) {

	},

	run_7: function( man ) {

	},


	run_8: function( man ) {

	},

};
